import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const myTaskService = {
  // ekyc
  getListEkyc,
  getDetailEkyc,
  getDroplistReason,

  // maintenance
  list,
  show,
  taskAction,
};

// eKYC -------------------------//
function getListEkyc(payload) {
  const { size, page, referenceNumber, dateCreated, objectId, objectName } = payload;

  const params = {
    wfName: 'approvalEkyc',
    size: size ? size : 10,
    page: page ? page : 1,
  };

  if (referenceNumber) params.referenceNumber = referenceNumber;
  if (dateCreated) params.dateCreated = dateCreated;
  if (objectId) params.objectId = objectId;
  if (objectName) params.objectName = objectName;

  return submit('GET', `${API_ENDPOINT}/api/v1/task/maintenance`, params, {});
}

function getDetailEkyc(id) {
  return submit('GET', `${API_ENDPOINT}/api/v1/onboarding/approval/${id}`, {}, {});
}

function getDroplistReason() {
  return submit('GET', `${API_ENDPOINT}/api/v1/reject_reason/droplist`);
}


// maintenance ----------------------------------//
function list(option = {}) {
  const {
    size,
    page,
    wfName,
    objectId,
    objectName,
    taskName,
    dateCreated,
    processStartTime,
    assignee,
  } = option;
  const params = {
    wfName: wfName ? wfName : 'approvalMaintenance',
    size: size ? size : 10,
    page: page ? page : 1,
  };

  if (objectId) params.objectId = objectId;
  if (objectName) params.objectName = objectName;
  if (taskName) params.taskName = taskName;
  if (dateCreated) params.dateCreated = dateCreated;
  if (processStartTime) params.processStartTime = processStartTime;
  if (assignee) params.assignee = assignee;

  return submit('GET', `${API_ENDPOINT}/api/v1/task/maintenance`, params, {});
}

function show(data) { 
  return submit(
    'GET',
    `${API_ENDPOINT}/api/v1/${data.module}/approval/${data.id}`,
    {},
    {},
  );
}

function taskAction(option) {
  return submit(
    'POST',
    `${API_ENDPOINT}/api/v1/${option.module}/approval/`,
    option.data,
    {},
  );
}

export default myTaskService;
